/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNewVersion = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21.9 8 12 1.8 2.1 8l9.9 6.2zM12 4.2 18.1 8 12 11.8 5.9 8zM2.556 16.897l.971-1.749 9.005 5.002-.971 1.748zm0-4 .971-1.749 9.005 5.002-.972 1.749zM19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgNewVersion as NewVersion };
